import { observer } from 'mobx-react';
import { FormFieldLine } from '../../../../../../components/form-field-line/form-field-line';
import { Input } from '../../../../../../components/inputs/input/input';
import { IValidationGroup } from '../../../../../../hooks/validation-group/validation-group-hook';
import ShipedgeCredentialsStore from '../../../stores/credentials/shipedge-credentials-store';
import { Toggle } from "../../../../../../components/inputs/toggle/toggle";
import React from "react";

interface IIntegrationProps {
    credentialsStore: ShipedgeCredentialsStore,
    vGroup: IValidationGroup,
}

const ShipedgeCredentials: React.FC<IIntegrationProps> = observer(({credentialsStore, vGroup}) => {
    return (
        <>
            <FormFieldLine label='Base API URL' required key='base_url'>
                <Input
                    value={credentialsStore.base_url}
                    onChange={v => credentialsStore.base_url = v}
                    validationGroup={vGroup}
                    required
                />
            </FormFieldLine>
            <FormFieldLine label='Api key' required key='api_key'>
                <Input
                    value={credentialsStore.api_key}
                    onChange={v => credentialsStore.api_key = v}
                    validationGroup={vGroup}
                    required
                />
            </FormFieldLine>
            <FormFieldLine label='Accound ID' required key='account_id'>
                <Input
                    value={credentialsStore.account_id}
                    onChange={v => credentialsStore.account_id = v}
                    validationGroup={vGroup}
                    required
                />
            </FormFieldLine>
            <FormFieldLine label='Warehouse ID' required key='warehouse'>
                <Input
                    value={credentialsStore.warehouse}
                    onChange={v => credentialsStore.warehouse = v}
                    validationGroup={vGroup}
                    required
                />
            </FormFieldLine>
            <FormFieldLine label='Return label' key='label'>
                <Toggle
                    label="Is return label needed"
                    onChange={ credentialsStore.checkLabelToggle }
                    checked={ credentialsStore.label }
                />
            </FormFieldLine>
        </>
    )
});

export default ShipedgeCredentials;
